import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {useCallback, useEffect, useMemo, useState} from "react";
import { useTranslation } from "react-i18next";
import { PRODUCTS_LIST } from "../../../locales/pages/namespaces";
import useUserData from "../../../hooks/user/useUserData";
import {useMediaQuery} from "@mui/material";
import Images from "../../../assets";
import useCartAction from "../../../hooks/cart/useCartAction";
import useCartData from "../../../hooks/cart/useCartData";
import {enqueueSnackbar} from "notistack";

const TOKENS = {
    radiusCard: 20,
    stroke: "#E9E9E9",
    panel: "#EFEFEF",
    thumbBg: "#FAFAFA",
    black: "#111111",
    text: "#333333",
    magenta: "#E5007E",
};
export default function ProductCard({
  product = {},
  onAddToCart = () => {},
  onClick = () => {},
                                        isFromList = false
}) {
  const { t } = useTranslation(PRODUCTS_LIST);
  const { id, name, price, priceOld, image, badge, specialOffer,colorId } =
    product;
  const { isLoggedIn } = useUserData();
    const {language} = useUserData()
    const isMobile = useMediaQuery("(max-width: 600px)");
    const{editCart,setCartMessage} = useCartAction()
    const { message } = useCartData();

    useEffect(() => {
        if (!message) return;

        const text =
            typeof message.get === "function" ? message.get("text") : message?.text;
        const variant =
            typeof message.get === "function"
                ? message.get("variant")
                : message?.variant || "error";

        if (!text) return;

        enqueueSnackbar(t("Failed to update cart!"), {variant:"error",});

        setCartMessage(null);
    }, [message, setCartMessage, t]);

  const selectedColorName = useMemo(
    () => product?.colors?.find((c) => c.id === colorId)?.name ?? "",
    [colorId, product?.colors]
  );

    const handleAddToCart = (id, product) => {
        if (!id) return;

        editCart({
            id: String(id),
            quantity: 1,
            suppressNotification: false,
            product: {
                id: String(id),
                title: product.name,
                image: product.image,
                price: Number(product.price) || 0,
                quantity: 1,
                code: product.code || "",
            },
        });
    };

  const handleCardClick = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    onClick && onClick();
  }, [onClick]);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        //transition: "all 0.3s ease",
        display: "flex",
        flexDirection: "column",
        p: { xs: 2, md: "30px 20px 35px 20px" },
        width: "100%", 
        maxWidth: 285,
        boxSizing: "border-box",
        bgcolor: isFromList ? '#EFEFEF':'#E9E9E9',
        position: "relative",
        zIndex: 30,
        minWidth: 0,
        "@media (hover: hover)": {
            "&:hover": {
                boxShadow: "0 0 15px rgba(0, 0, 0, 0.28)",
            },
            // "& img": {
            //     transition: "transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), filter 0.5s",
            // },
            "&:hover img": {
                transform: "scale(1.07) translateY(-3px)",
                filter: "drop-shadow(0 12px 20px rgba(0,0,0,0.18))",
            },
            "&:hover button": {
                color: "#fff",
                backgroundColor: "#E5007E",
            },
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: { xs: 140, sm: 160, md: 200 }, 
          display: "grid",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 2,
          mb: 2,
          overflow: "hidden",
          width: "100%",
        }}
      >
          <Box sx={{width:'100%',display:'flex',justifyContent:'flex-end'}}>
              {specialOffer === '1' && (
                  <Chip
                      label={"SPECIAL OFFER"}
                      sx={{
                          backgroundColor: "#fff",
                          borderRadius: 5,
                          color: "#E5007E",
                          fontWeight: 900,
                          lineHeight: "120%",
                          width:'50%',
                          height: 20,
                          fontFamily: "Zen Maru Gothic",
                          fontSize: "12px",
                          zIndex: 2,
                          cursor: "pointer",
                          "& .MuiChip-label": { px: 1 },
                      }}
                  />
              )}
          </Box>
        <Box
          component="img"
          src={image}
          alt={name}
          sx={{
              width: "100%",
              aspectRatio: "4 / 3",
              objectFit: "contain",
              display: "grid",
              placeItems: "center",
              overflow: "hidden",
              borderRadius: 2,
              transition: "transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
              willChange: "transform",
          }}
        />
      </Box>

      <Stack
        spacing={1.2}
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body2"
          onClick={handleCardClick}
          sx={{
            fontWeight: 500,
            fontSize: 14,
            fontFamily: "Zen Maru Gothic",
            lineHeight: "110%",
            color: "#111",
            textTransform: "uppercase",
            letterSpacing: 0.2,
            minHeight: "2.6em",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            cursor: "pointer",
          }}
        >
          {name}
        </Typography>
{isLoggedIn && (
    <>
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="baseline"
          onClick={handleCardClick}
          sx={{ pb: 1, cursor: "pointer" }}
        >
        
          {priceOld && price !== priceOld ? (
            <>
              <Typography
                variant="body2"
                sx={{
                  textDecoration: "line-through",
                  color: "#E5007E",
                  fontSize: 15,
                  fontWeight: 700,
                  lineHeight: "120%",
                  fontFamily: "Roboto",
                }}
              >
                {priceOld?.toFixed(2)}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#000",
                  fontSize: 15,
                  lineHeight: 1,
                  fontFamily: "Roboto",
                }}
              >
                {price?.toFixed(2)}€
              </Typography>
            </>
          ) : (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#000",
                fontSize: 15,
                lineHeight: 1,
                fontFamily: "Roboto",
              }}
            >
              {price?.toFixed(2)}€
            </Typography>
          )}
        </Stack>

        <Button
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
              handleAddToCart(id,product)
          }}
          sx={{
            border: "none",
            color: "#000",
            fontWeight: 900,
            fontSize: 14,
            letterSpacing: 0.3,
            p: "6px 12px",
            minWidth: "auto",
            height: "28px",
            alignSelf: "flex-start",
          }}
        >
          {t("Add")}
        </Button>
        </>
)}
      </Stack>
    </Paper>
  );
}
